import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 pt-8 pb-6 sm:pt-16 sm:pb-8 px-4 sm:px-6 lg:px-8 border-t-4 border-agua" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <div className="flex flex-col items-center text-center mb-6 sm:mb-12" data-id="element-104">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-4" data-id="element-105">
            PROFE DE NATACIÓN <span className="text-turquoise" data-id="element-106">RESUELTO™</span>
          </h2>
          <p className="text-gray-400 max-w-xl text-sm sm:text-base" data-id="element-107">
            El sistema de clases N°1 para profes de natación en Argentina.
            Porque enseñar en el agua no debería costarte todas las noches de la
            semana.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-6 sm:gap-10 mb-6 sm:mb-12" data-id="element-108">
          <a href="mailto:contacto@recursosfitness.shop" className="flex items-center gap-2 text-gray-300 hover:text-turquoise transition-colors" data-id="element-109">
            <Mail className="w-5 h-5 text-turquoise" data-id="element-110" />
            <span data-id="element-111">contacto@recursosfitness.shop</span>
          </a>
          <a href="#" className="flex items-center gap-2 text-gray-300 hover:text-turquoise transition-colors" data-id="element-112">
            <Instagram className="w-5 h-5 text-turquoise" data-id="element-113" />
            <span data-id="element-114">@recursosfitness.ar</span>
          </a>
          <a href="https://recursosfitness.shop" className="flex items-center gap-2 text-gray-300 hover:text-turquoise transition-colors" data-id="element-115">
            <Globe className="w-5 h-5 text-turquoise" data-id="element-116" />
            <span data-id="element-117">recursosfitness.shop</span>
          </a>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center" data-id="element-118">
          <p className="text-gray-500 text-sm" data-id="element-119">
            © RecursosFitness™ 2026 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}